// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Inter";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color:white !important;

}

input#emailId {
  height: 12px;
}

input#outlined-adornment-password {
  height: 12px;
}


code {
  font-family: "Inter"
}

.logo-login {
  /* max-width: 20%; */
  position: fixed;
  /* width: 285px; */
  /* height: 
  
  ; */
}

.logo-icon {
  width: 100%;
}

.logo-login-right{
  width: 267.85px;
}

.login-body-right {
  position: absolute;
  /* top: 57%; */
  left: 90%;
  /* transform: translate(-50%, -50%); */
  width: 20%;
}

.logo-loginright{
  max-width: 40%;
}

.login-body {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* background-color: #fff; */
}

.login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
}

.googleLoginBtn {
  cursor: pointer;
  /* border-radius: 20px; */
  width: 168px;
}



/* .rbc-event, .rbc-day-slot .rbc-background-event {
  background-color: #002C5D;
  color: #fff;
}
.rbc-calendar *, .rbc-calendar *:before, .rbc-calendar *:after {
  box-sizing: inherit;
} */

/* Small screens (phones) */
@media only screen and (max-width: 767px) {
  .logo-login {
    max-width: 50%;
  }
}



/* Medium screens (tablets) */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .logo-login {
    max-width: 40%;
  }
}

/* Extra large screens (standard desktops) */
@media only screen and (min-width: 1200px) {
  /* Styles for extra large screens go here */
}

.loader {
  position: relative;
  width: 120px;
  height: 90px;
  margin: 0 auto;
}
.loader:before {
  content: "";
  position: absolute;
  bottom: 30px;
  left: 50px;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background: #ff3d00;
  animation: loading-bounce 0.5s ease-in-out infinite alternate;
}
.loader:after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  height: 7px;
  width: 45px;
  border-radius: 4px;
  box-shadow: 0 5px 0 #fff, -35px 50px 0 #fff, -70px 95px 0 #fff;
  animation: loading-step 1s ease-in-out infinite;
}

@keyframes loading-bounce {
  0% {
    transform: scale(1, 0.7);
  }
  40% {
    transform: scale(0.8, 1.2);
  }
  60% {
    transform: scale(1, 1);
  }
  100% {
    bottom: 140px;
  }
}
@keyframes loading-step {
  0% {
    box-shadow: 0 10px 0 rgba(0, 0, 0, 0), 0 10px 0 #fff, -35px 50px 0 #fff,
      -70px 90px 0 #fff;
  }
  100% {
    box-shadow: 0 10px 0 #fff, -35px 50px 0 #fff, -70px 90px 0 #fff,
      -70px 90px 0 rgba(0, 0, 0, 0);
  }
}

/* .rbc-time-view {
  .rbc-label {
  display: none;
  }
  .rbc-allday-cell {
  height: calc(100vh - 98px);
  max-height: unset;
  }
  .rbc-time-content {
  display: none;
  }
  } */



.css-1j74v90-MuiListItemText-root {
  color:#002C5D
}
.css-3ze1g6-MuiListItem-root{
  background-color:#002C5D ;
  border-radius: 20% !important;
}


.css-vu9eu9-MuiListItem-root {
  background-color:#E5F0FC !important;
  border-radius: 30px;
}



/* .rbc-time-view {
  .rbc-label {
  display: none;
  }
  .rbc-allday-cell {
  height: calc(100vh - 98px);
  max-height: unset;
  }
  .rbc-time-content {
  display: none;
  }
  } */
  .Firstline{
    display: flex;
    justify-content: space-between;
  }
  .Firstline h4{
    margin: 0px;
    font-weight: 600;
    size: 14px;
    color: #002C5D;
    
    
  }
  .Firstline h3{
    margin-top: 2px;
    size: 16px;
  }
  .linetwo {
    justify-content: space-between;
    display: flex;
  }
  .linetwo h4{
    margin: 0px;
    font-weight: 600;
    size: 14px;
    color: #002C5D; 
   
  }
  .Leave-div{
    padding: 6px 14px 6px 16px;;
    background-color: #e5f0fc;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    border-radius: 8px;
    align-items: center;
  }
  .Leave-div ,h3,h1{
    color: #0056B2;
  }
  .PTO-div{
    background-color: #e9d20045;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 6px 14px 6px 16px;;
    display: flex;
    align-items: center;
  }
  .PTO-div ,h3,h1{
    color:  #0056B2;
    
  }
  .Table-div{
    margin-top: 30px;
  }
  .Btn-div{
    margin-top: 25px;
    display: flex;
    justify-content: flex-end;
    gap: 30px;
  }
  .WeekBtn{
    border: solid 1px  #8798A9;
    
display: flex;
align-items: center;
  }

  .beforeicon{
    color: #8798A9;
    cursor: pointer;
  }
  .aftericon{
    color: #8798A9;
    cursor: pointer;
  }
  .Approval-BTN{
    color: #fff !important;
    background-color: #ff3d00 !important;
    font-weight: 600 !important;

  }
  .Copy-Btn{
color: #ff3d00 !important;
border-color: #ff3d00 !important;

  }
  .Team-view{
    display: flex;
    justify-content: space-between;
  }
  .Switch-div{
    display: flex;
    justify-content: center;
  }
  .tablecell{
    color: #0070E9 !important;
  }
  .eyeIcon{
    color: #0070E9 ;
  }
  .ModalDIv{
    display: flex;
    justify-content: space-around;
    padding: 0px 40px 0px 40px ;
    gap: 15px;
  }`, "",{"version":3,"sources":["webpack://./src/assets/styles/custom.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;;AAEnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB;;KAEG;AACL;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;;;AAIA;;;;;;GAMG;;AAEH,2BAA2B;AAC3B;EACE;IACE,cAAc;EAChB;AACF;;;;AAIA,6BAA6B;AAC7B;EACE;IACE,cAAc;EAChB;AACF;;AAEA,4CAA4C;AAC5C;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;AAC/D;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,8DAA8D;EAC9D,+CAA+C;AACjD;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE;uBACmB;EACrB;EACA;IACE;mCAC+B;EACjC;AACF;;AAEA;;;;;;;;;;;KAWK;;;;AAIL;EACE;AACF;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;;AAGA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;;;AAIA;;;;;;;;;;;KAWK;EACH;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,cAAc;;;EAGhB;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,cAAc;;EAEhB;EACA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,8CAA8C;IAC9C,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,2BAA2B;IAC3B,8CAA8C;IAC9C,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,eAAe;;EAEjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,SAAS;EACX;EACA;IACE,0BAA0B;;AAE9B,aAAa;AACb,mBAAmB;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,2BAA2B;;EAE7B;EACA;AACF,yBAAyB;AACzB,gCAAgC;;EAE9B;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;IAC3B,SAAS;EACX","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Inter\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color:white !important;\n\n}\n\ninput#emailId {\n  height: 12px;\n}\n\ninput#outlined-adornment-password {\n  height: 12px;\n}\n\n\ncode {\n  font-family: \"Inter\"\n}\n\n.logo-login {\n  /* max-width: 20%; */\n  position: fixed;\n  /* width: 285px; */\n  /* height: \n  \n  ; */\n}\n\n.logo-icon {\n  width: 100%;\n}\n\n.logo-login-right{\n  width: 267.85px;\n}\n\n.login-body-right {\n  position: absolute;\n  /* top: 57%; */\n  left: 90%;\n  /* transform: translate(-50%, -50%); */\n  width: 20%;\n}\n\n.logo-loginright{\n  max-width: 40%;\n}\n\n.login-body {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  /* background-color: #fff; */\n}\n\n.login-box {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 30%;\n}\n\n.googleLoginBtn {\n  cursor: pointer;\n  /* border-radius: 20px; */\n  width: 168px;\n}\n\n\n\n/* .rbc-event, .rbc-day-slot .rbc-background-event {\n  background-color: #002C5D;\n  color: #fff;\n}\n.rbc-calendar *, .rbc-calendar *:before, .rbc-calendar *:after {\n  box-sizing: inherit;\n} */\n\n/* Small screens (phones) */\n@media only screen and (max-width: 767px) {\n  .logo-login {\n    max-width: 50%;\n  }\n}\n\n\n\n/* Medium screens (tablets) */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .logo-login {\n    max-width: 40%;\n  }\n}\n\n/* Extra large screens (standard desktops) */\n@media only screen and (min-width: 1200px) {\n  /* Styles for extra large screens go here */\n}\n\n.loader {\n  position: relative;\n  width: 120px;\n  height: 90px;\n  margin: 0 auto;\n}\n.loader:before {\n  content: \"\";\n  position: absolute;\n  bottom: 30px;\n  left: 50px;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  background: #ff3d00;\n  animation: loading-bounce 0.5s ease-in-out infinite alternate;\n}\n.loader:after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 7px;\n  width: 45px;\n  border-radius: 4px;\n  box-shadow: 0 5px 0 #fff, -35px 50px 0 #fff, -70px 95px 0 #fff;\n  animation: loading-step 1s ease-in-out infinite;\n}\n\n@keyframes loading-bounce {\n  0% {\n    transform: scale(1, 0.7);\n  }\n  40% {\n    transform: scale(0.8, 1.2);\n  }\n  60% {\n    transform: scale(1, 1);\n  }\n  100% {\n    bottom: 140px;\n  }\n}\n@keyframes loading-step {\n  0% {\n    box-shadow: 0 10px 0 rgba(0, 0, 0, 0), 0 10px 0 #fff, -35px 50px 0 #fff,\n      -70px 90px 0 #fff;\n  }\n  100% {\n    box-shadow: 0 10px 0 #fff, -35px 50px 0 #fff, -70px 90px 0 #fff,\n      -70px 90px 0 rgba(0, 0, 0, 0);\n  }\n}\n\n/* .rbc-time-view {\n  .rbc-label {\n  display: none;\n  }\n  .rbc-allday-cell {\n  height: calc(100vh - 98px);\n  max-height: unset;\n  }\n  .rbc-time-content {\n  display: none;\n  }\n  } */\n\n\n\n.css-1j74v90-MuiListItemText-root {\n  color:#002C5D\n}\n.css-3ze1g6-MuiListItem-root{\n  background-color:#002C5D ;\n  border-radius: 20% !important;\n}\n\n\n.css-vu9eu9-MuiListItem-root {\n  background-color:#E5F0FC !important;\n  border-radius: 30px;\n}\n\n\n\n/* .rbc-time-view {\n  .rbc-label {\n  display: none;\n  }\n  .rbc-allday-cell {\n  height: calc(100vh - 98px);\n  max-height: unset;\n  }\n  .rbc-time-content {\n  display: none;\n  }\n  } */\n  .Firstline{\n    display: flex;\n    justify-content: space-between;\n  }\n  .Firstline h4{\n    margin: 0px;\n    font-weight: 600;\n    size: 14px;\n    color: #002C5D;\n    \n    \n  }\n  .Firstline h3{\n    margin-top: 2px;\n    size: 16px;\n  }\n  .linetwo {\n    justify-content: space-between;\n    display: flex;\n  }\n  .linetwo h4{\n    margin: 0px;\n    font-weight: 600;\n    size: 14px;\n    color: #002C5D; \n   \n  }\n  .Leave-div{\n    padding: 6px 14px 6px 16px;;\n    background-color: #e5f0fc;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);\n    display: flex;\n    border-radius: 8px;\n    align-items: center;\n  }\n  .Leave-div ,h3,h1{\n    color: #0056B2;\n  }\n  .PTO-div{\n    background-color: #e9d20045;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    padding: 6px 14px 6px 16px;;\n    display: flex;\n    align-items: center;\n  }\n  .PTO-div ,h3,h1{\n    color:  #0056B2;\n    \n  }\n  .Table-div{\n    margin-top: 30px;\n  }\n  .Btn-div{\n    margin-top: 25px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 30px;\n  }\n  .WeekBtn{\n    border: solid 1px  #8798A9;\n    \ndisplay: flex;\nalign-items: center;\n  }\n\n  .beforeicon{\n    color: #8798A9;\n    cursor: pointer;\n  }\n  .aftericon{\n    color: #8798A9;\n    cursor: pointer;\n  }\n  .Approval-BTN{\n    color: #fff !important;\n    background-color: #ff3d00 !important;\n    font-weight: 600 !important;\n\n  }\n  .Copy-Btn{\ncolor: #ff3d00 !important;\nborder-color: #ff3d00 !important;\n\n  }\n  .Team-view{\n    display: flex;\n    justify-content: space-between;\n  }\n  .Switch-div{\n    display: flex;\n    justify-content: center;\n  }\n  .tablecell{\n    color: #0070E9 !important;\n  }\n  .eyeIcon{\n    color: #0070E9 ;\n  }\n  .ModalDIv{\n    display: flex;\n    justify-content: space-around;\n    padding: 0px 40px 0px 40px ;\n    gap: 15px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
